<template>
    <div class="w-100 mt-5" v-if="$integrations && websites.length > 0">
        <div class="row pb-10" style="border-bottom: 1px solid #E0E0E0;" v-if="$integrations.connectedIntegrations && $integrations.connectedIntegrations.length > 0">
            <div class="d-flex flex-column pl-0  pb-0 col-md-11">
                <p class="ma-0 fw-600 fs-24">
                    Manage your apps
                </p>
                <connected_integration :integration="integration" v-for="integration in $integrations.connectedIntegrations"></connected_integration>
            </div>
        </div>
        <div class="row mt-0 pt-8">
            <div class="d-flex flex-column pl-0 col-md-12">
                <div class="d-flex justify-space-between align-center">
                    <p class="ma-0 fw-600 fs-24">
                        Connect an app
                    </p>
                    <secondary-button @clickBtn="showVideo = true" :activeButton="true">See how it works</secondary-button>
                </div>
                <p class="ma-0 fw-400 fs-18">
                    Here you can integrate your drop account with one of our supported solutions. Ready?
                </p>

                <div  v-if="billing && billing.payment_method" class="row justify-space-between">
                    <single_integration_preview @click="$route.push('integration/'+type.type)" :integration="type" v-for="type in $integrations.types"></single_integration_preview>
                </div>
                <div v-else-if="!loading"  class="col-md-5 mt-10 pa-0 white-container d-flex flex-column justify-space-between">

                    <p class="ma-0 pa-5 fw-600 fs-18" >
                        You need to connect your credit card to integrate with other platforms.
                    </p>
                    <p class="ma-0 pa-5 pt-0 fw-500 fs-14">
                        Your credit card is charged only when fulfilling orders placed on external platforms (for example Shopify).<br>This is because you will be charging your customers directly for the whole order.
                    </p>
                    <div class="w-100 pa-5 d-flex justify-space-between">
                        <v-img max-width="100px" max-height="50px" contain :src="$root.getSrc('default/drop_icons/stripe.png')" alt="Drop" />
                        <primary-button :to="'/user/edit'" :activeBtn="true">Connect card</primary-button>
                    </div>
                </div>
                <div v-else class="col-md-5 mt-10 pa-0 white-container">
                    <v-skeleton-loader
                        class="mx-auto"
                        type="card"
                    ></v-skeleton-loader>
                </div>
            </div>
            <div class="col-md-2"></div>
        </div>
        <v-dialog
            v-model="showVideo"
            width="40vw"
        >
            <v-card>
                <v-card-title class="">
                    How it works
                </v-card-title>

                <v-card-text class="d-flex align-center justify-center">
                    <iframe width="560" height="315" :src="$root.getSrc('videos/drop-shopify-screencast.mp4')" title="Shopify - How it works" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions class="pb-0">
                    <v-spacer></v-spacer>
                    <primary-button class="pt-5 pb-5" :activeBtn="true" @clickBtn="showVideo = false">Close</primary-button>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div v-else class="w-100 mt-5">
        <div class="d-flex justify-space-between mb-5">
            <p class="ma-0 fs-36 fw-400">You need to create website first</p>
            <v-btn v-ripple="false"  to="/websites/create"  class="ml-2 white--text drop-button button-primary-active" color="#2F80ED">
                Create new website
            </v-btn>
        </div>

        <v-skeleton-loader
            v-bind="attrs"
            type="image, actions"
        ></v-skeleton-loader>
    </div>
</template>
<script>
import Integrations from '../../plugins/integrations';
import Vue from 'vue';
import {getBillings} from "@/api/billings";
export default {
    components:{
        'single_integration_preview': () => import('./integration_single_preview'),
        'connected_integration': () => import('./connected_integration')
    },
    beforeDestroy(){
        Vue.prototype.$integrations.$destroy();
    },
    beforeCreate(){
        Vue.prototype.$integrations = new Vue(Integrations);
        this.$integrations.init();
    },
    data:()=>{
      return {
          loading: false,
          billing: null,
          showVideo: false,
          attrs: {
              class: 'mb-6',
              boilerplate: true,
              elevation: 2,
          },
      }
    },
    methods:{
        getBillings(first = true){
            this.loading = true;
            if(first) this.firstLoading = true;
            getBillings().then(res => {
                this.billing = res;
                this.loading = false;
                this.firstLoading = false;
            })
        },
    },
    mounted() {
        this.getBillings();
    },
    computed:{
        websites(){
            return this.$store.getters.websites;
        },
    }
}
</script>
